export const financesForms = (state) => state.financesForms
export const totalFinancesForms = (state) => state.totalFinancesForms
export const selectAllField = (state) => state.selectAllField
